import { makeStyles } from '@material-ui/core';
import { Grid } from '@mui/material';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import React, { useEffect } from 'react';
import Autocomplete2 from 'components/Autocomplete2';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  reportContainer: {
    display: 'flex',
  },
  reportSelection: {
    flex: 0.3,
  },
  reportFilter: {
    flex: 0.7,
  },
  report: {
    paddingBottom: '4px',
  },
  filterfield:
  {
    marginLeft: '0px',
    marginRight: '0px',
    marginBottom: '8px',
    marginTop: '0px',
  }

}));


const CADPialSummary = (props) => {
  const classes = useStyles();
  const { reportForm, handleReportFormChange, ReportID } = props;
  const formValue = reportForm[ReportID] || {};
  const agencies =  useSelector((state) => state.dictionary?.Agencies ?? []);
  const agenciesList = agencies.map(item => ({
    Code: item.AgencyID
  }));
  const agency = { Code : useSelector((state) => state.user.userData.user.AgencyID).toString() };
  useEffect(() => {
    if (!formValue.agency) {
      handleReportFormChange(ReportID, "agency", agency);
    }
  }, []);
  return (
    <div className={classes.report}>
      <Grid container justify="left" alignItems="center" spacing={1}>
        <Grid item xl={2} md={2} sm={12} xs={12} className={classes.marginNormal}>
          <Autocomplete2
            options={agenciesList} 
            className={classes.filterfield}
            onChange={(ev, newVal) => handleReportFormChange(ReportID, 'agency', newVal)}
            value={formValue.agency ?? null}
            label="Agency"
            compact="True"
            error={!formValue.agency}
          />
        </Grid>

        <Grid item xl={4} md={4} sm={12} xs={12} className={classes.marginNormal}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              disableOpenOnEnter
              className={classes.filterfield}
              autoComplete="off"
              fullWidth
              clearable
              size="small"
              inputVariant="outlined"
              showTodayButton={true}
              variant="dialog"
              format="MM/dd/yyyy"
              id="date-picker-inline-from"
              label="Start Date"
              defaultValue={null}
              value={formValue.startDate || null}
              onChange={(date) =>
                handleReportFormChange(ReportID, 'startDate', date)
              }
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
            />
          </MuiPickersUtilsProvider>
        </Grid>

        <Grid item xl={4} md={4} sm={12} xs={12}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              disableOpenOnEnter
              className={classes.filterfield}
              autoComplete="off"
              fullWidth
              clearable
              size="small"
              inputVariant="outlined"
              showTodayButton={true}
              variant="dialog"
              format="MM/dd/yyyy"
              id="date-picker-inline-to"
              label="End Date"
              defaultValue={null}
              value={formValue.endDate || null}
              onChange={(date) =>
                handleReportFormChange(ReportID, 'endDate', date)
              }
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
            />
          </MuiPickersUtilsProvider>
        </Grid>

      </Grid>
    </div>
  );
};

export default CADPialSummary;